import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

const LicensePlateContainer = styled(Paper)({
  alignItems: 'center',
  backgroundColor: 'white',
  borderRadius: '10px',
  border: '2px solid black',
  display: 'flex',
  height: 35,
  minWidth: 150,
  position: 'relative',
  overflow: 'hidden',
});

const EuBand = styled(Box)({
  width: 25,
  minHeight: '100%',
  backgroundColor: '#003399',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  color: 'white',
  position: 'relative',
});

const StarCircle = styled(Box)({
  width: 10,
  height: 10,
  position: 'relative',
  marginBottom: 3,
});

const Star = styled(Box)<{ index: number }>(({ index }) => ({
  position: 'absolute',
  color: '#FFCC00',
  fontSize: '2px',
  fontWeight: 'bold',
  left: '50%',
  top: '70%',
  transform: `rotate(${index * 30}deg) translate(0, -7px)`,
  transformOrigin: '0 0',
}));

const CountryCode = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '8px',
});

const PlateContent = styled(Box)({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
});

const PlateNumber = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  fontSize: '19px',
});

const CountyCode = styled(Typography)({
  color: '#000',
  fontWeight: 700,
  fontSize: 'inherit',
});

const LicensePlate = ({ licenseNumber }: { licenseNumber: string; }) => {
  const stars = Array.from({ length: 12 }, (_, i) => i);

  return (
    <Box display="flex" alignItems="center">
      <LicensePlateContainer elevation={3}>
        <EuBand>
          <StarCircle>
            {stars.map((index) => (
              <Star key={index} index={index}>★</Star>
            ))}
          </StarCircle>
          <CountryCode variant="body1">RO</CountryCode>
        </EuBand>
        <PlateContent>
          <PlateNumber>
            <CountyCode>
              {licenseNumber.replace(/([A-Za-z]+)(\d+)([A-Za-z]+)/, '$1 $2 $3')}
            </CountyCode>
          </PlateNumber>
        </PlateContent>
      </LicensePlateContainer>
    </Box>
  );
};

export default LicensePlate;